import {
  COMPOUND_INTEREST_FORMULA,
  getTimeInYears,
} from './compound-interest-formula';

export interface SIMPLE_COMPOUND_CALCULATOR_PROPS {
  principleAmount: number | undefined;
  annualrate: number | undefined;
  periodInDigit: number | undefined;
  periodUnit: string | undefined;
  compoundFrequency: string | undefined;
  investmentOption: string | undefined;
}

export const SIMPLE_COMPOUND_INTEREST_FORMULA = ({
  principleAmount,
  annualrate,
  periodInDigit,
  periodUnit,
  compoundFrequency,
  investmentOption,
}: SIMPLE_COMPOUND_CALCULATOR_PROPS) => {
  if (
    !principleAmount ||
    !annualrate ||
    !periodInDigit ||
    !periodUnit ||
    (!compoundFrequency && investmentOption !== 'simple_interest') ||
    !investmentOption ||
    Number(principleAmount) < 0 ||
    Number(annualrate) < 0 ||
    Number(periodInDigit) < 0
  ) {
    return {
      interestEarned: 0,
      resultPrincipalAmount: 0,
      totalValue: 0,
    };
  }

  let interestEarned = 0;
  const timeInYears = getTimeInYears(periodUnit, periodInDigit);

  if (investmentOption === 'simple_interest') {
    interestEarned = Number(
      (principleAmount * (annualrate / 100) * timeInYears).toFixed(2)
    );
    return {
      interestEarned,
      resultPrincipalAmount: principleAmount,
      principleAmount,
      totalValue: Number(interestEarned) + Number(principleAmount),
    };
  } else {
    return COMPOUND_INTEREST_FORMULA({
      principleAmount,
      annualrate,
      periodInDigit,
      periodUnit,
      compoundFrequency,
    });
  }
};
